export enum DIGITAL_PHONE {
  ru = '8 800 333-44-01',
  kz = '(727) 237-77-04',
  uz = '+998 78 150 40 84',
}

export enum PERIODIC_PHONE {
  ru = '8 800 333-00-65',
  kz = '(727) 237-77-04',
  uz = '+998 71 150 40 84',
}
